function accessoryStorageGet(property = null) {
  let data = localStorage.getItem('mgconf_accessories_shop')
  if (typeof data === 'undefined' || data === null) {
    return undefined
  } else {
    data = JSON.parse(data)
  }

  return property === null ? data : data[property]
}

function accessoryStorageSet(property, value) {
  let data = localStorage.getItem('mgconf_accessories_shop')
  if (typeof data === 'undefined' || data === null) {
    data = {}
  } else {
    data = JSON.parse(data)
  }

  data[property] = value
  localStorage.setItem('mgconf_accessories_shop', JSON.stringify(data))
  window.dispatchEvent( new Event('storage') )
}

function accessoryStorageClear() {
  localStorage.removeItem('mgconf_accessories_shop')
}

function accessoryIsArrayDiff(array1, array2, key = null) {
  const array1Diff = array1.filter((item) => {
    if (key !== null) {
      return !array2.map((item) => item[key]).includes(item[key])
    }

    return !array2.includes(item)
  })

  const array2Diff = array2.filter((item) => {
    if (key !== null) {
      return !array1.map((item) => item[key]).includes(item[key])
    }

    return !array1.includes(item)
  })

  return array1Diff.length > 0 || array2Diff.length > 0
}

export { accessoryStorageGet, accessoryStorageSet, accessoryStorageClear, accessoryIsArrayDiff }
